// Version mapping for policy versions to chart data files
const VERSION_MAP = {
  'AVB TKV 09-2024pi': '09-2024pi',
  'AVB TKV 02-2026pi': '02-2026pi',
};

// Default fallback version
const DEFAULT_VERSION = '09-2024pi';

/**
 * Get chart data for a specific policy version
 * @param {string} policyVersion - The policy version string (e.g., "AVB TKV 02-2026pi")
 * @returns {Promise<object>} - The chart data object
 */
export const getChartDataByVersion = async (policyVersion) => {
  try {
    // Get the version key from the mapping
    const versionKey = VERSION_MAP[policyVersion] || DEFAULT_VERSION;
    
    console.log(`Loading chart data for policy version: ${policyVersion} (key: ${versionKey})`);
    
    // Dynamically import the version-specific data
    const module = await import(`./versions/${versionKey}.js`);
    
    return module.chartData;
  } catch (error) {
    console.error(`Failed to load chart data for version ${policyVersion}:`, error);
    
    // Fallback to default version
    console.log(`Falling back to default version: ${DEFAULT_VERSION}`);
    const fallbackModule = await import(`./versions/${DEFAULT_VERSION}.js`);
    return fallbackModule.chartData;
  }
};

/**
 * Check if a policy version is supported
 * @param {string} policyVersion - The policy version string
 * @returns {boolean} - True if the version is supported
 */
export const isSupportedVersion = (policyVersion) => {
  return VERSION_MAP.hasOwnProperty(policyVersion);
};

/**
 * Get all supported policy versions
 * @returns {string[]} - Array of supported policy version strings
 */
export const getSupportedVersions = () => {
  return Object.keys(VERSION_MAP);
};
